import React from "react";

type Props = {
  width: number;
  height: number;
};

export const AdDatabaseSVG: React.FC<Props> = (props) => {
  const { width, height } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox={`0 0 38 38`}
      fill="currentColor"
      opacity="0.6"
    >
      <g transform="translate(4.668)">
        <path
          d="M127.927,65.74H108.1A4,4,0,0,0,104.18,69.8V97.18a4,4,0,0,0,3.922,4.059h19.825a4,4,0,0,0,3.921-4.059V69.8A4,4,0,0,0,127.927,65.74Zm2.065,31.44a2.105,2.105,0,0,1-2.065,2.138H108.1a2.1,2.1,0,0,1-2.065-2.138V69.8a2.1,2.1,0,0,1,2.065-2.138h19.825a2.1,2.1,0,0,1,2.065,2.138Z"
          transform="translate(-104.18 -65.74)"
        />
      </g>
      <g transform="translate(0 4.398)">
        <path
          d="M61.663,135.066a1.708,1.708,0,0,1-1.744-1.665V112.077a1.708,1.708,0,0,1,1.744-1.665h.013v-1.5h-.013a3.243,3.243,0,0,0-3.312,3.161V133.4a3.243,3.243,0,0,0,3.312,3.161h.013v-1.5Z"
          transform="translate(-58.351 -108.916)"
        />
      </g>
      <g transform="translate(33.781 4.398)">
        <path
          d="M390.013,135.066a1.708,1.708,0,0,0,1.744-1.665V112.077a1.708,1.708,0,0,0-1.744-1.665H390v-1.5h.013a3.243,3.243,0,0,1,3.312,3.161V133.4a3.243,3.243,0,0,1-3.312,3.161H390v-1.5Z"
          transform="translate(-390 -108.916)"
        />
      </g>

      <g transform="translate(10.275 6.02)">
        <path
          d="M174.591,129.817l-.476.274-1.9,1.1v-3.66a.375.375,0,0,0-.562-.325l-.536.309-.476.274-1.9,1.1v-3.663a.375.375,0,0,0-.562-.325l-8.768,5.064a.375.375,0,0,0-.187.325V143.2a.375.375,0,0,0,.563.325l.533-.308.476-.277,1.9-1.1v3.663a.375.375,0,0,0,.563.325l.533-.308.476-.274,1.9-1.1v3.66a.375.375,0,0,0,.562.325l1.009-.582,7.763-4.481a.375.375,0,0,0,.188-.325V129.834a.375.375,0,0,0-.563-.325Zm-11.706,2.448a.375.375,0,0,0-.187.325v7.942a.375.375,0,0,1-.188.325l-.288.166-1.334.77a.375.375,0,0,1-.562-.325V130.745a.375.375,0,0,1,.188-.325l6.578-3.8a.375.375,0,0,1,.562.325V129.3a.375.375,0,0,1-.188.325l-4.145,2.394Zm.908,11.513V141.43a.375.375,0,0,1,.188-.325l4.581-2.645a.375.375,0,0,0,.187-.325V137.9a.375.375,0,0,0-.562-.325l-3.831,2.212a.375.375,0,0,1-.562-.325v-6.414a.375.375,0,0,1,.188-.325l3.673-2.12,1.1-.633.476-.274,1.334-.77a.375.375,0,0,1,.562.325V131.6a.375.375,0,0,1-.187.325l-4.581,2.645a.375.375,0,0,0-.187.325v.229a.375.375,0,0,0,.562.325l3.831-2.212a.375.375,0,0,1,.562.325v6.417a.375.375,0,0,1-.187.325l-3.67,2.12-1.1.633-1.809,1.044A.375.375,0,0,1,163.793,143.778Zm10.611-1.166-6.578,3.8a.375.375,0,0,1-.562-.325v-2.348a.375.375,0,0,1,.187-.325l4.581-2.645a.375.375,0,0,0,.188-.325V132.5a.375.375,0,0,1,.188-.325l.288-.166,1.334-.77a.375.375,0,0,1,.562.325v10.726A.375.375,0,0,1,174.4,142.612Z"
          transform="translate(-159.231 -124.841)"
        />
      </g>
    </svg>
  );
};
